<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" fill="none" viewBox="0 0 10 10">
        <path
            fill="#8a8a94"
            fill-rule="evenodd"
            d="M2 1c0-.552285.44772-1 1-1h6c.55228 0 1 .447715 1 1v6c0 .55228-.44771 1-1 1s-1-.44772-1-1V3.41421l-6.29289 6.2929c-.39053.39049-1.023692.39049-1.414217 0-.390524-.39053-.3905241-1.02369 0-1.41422L6.58579 2H3c-.55228 0-1-.44772-1-1"
            clip-rule="evenodd"
        />
    </svg>
</template>
